"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Image from "next/image";
import { env } from "@/lib/environment";

import "swiper/css";
import "swiper/css/autoplay";

const cdnBaseUrl = env.NEXT_PUBLIC_CDN_URL;

const galleryImages = [
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-1.kzcm4N323C2C.webp`,
    alt: "Digital signage content playing on a display at a retail store which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-2.g2CkFjvw98jD.webp`,
    alt: "Digital signage content playing on a display at Etisalat premises which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-3.LVA-utC7vj1H.webp`,
    alt: "Digital signage content playing on a display at IAS office premises which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-4.MAgE1vMGRzRA.webp`,
    alt: "Digital signage content playing on a display at SAYA real estate office lobby which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-5.SSE1hE8K-8Gr.webp`,
    alt: "Digital signage content playing on a display at corporate office lobby which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-6.cr7qFiE5HtGH.webp`,
    alt: "Digital signage content playing on a display at hospital lobby which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-7.NDWFJh4nPSxz.webp`,
    alt: "Digital signage content playing on a display at a clothing store which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-8.S4O1VLPmsigU.webp`,
    alt: "Digital signage content playing on a video wall display at a mall premises which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-9.QrNbbC3KBCot.webp`,
    alt: "Digital signage content playing on a Amazon stall display at a mall premises which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-11.jq4pJLEc9tZE.webp`,
    alt: "Digital signage menu content playing on a display at a cafe which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-12.xBkCBt8jrYCx.webp`,
    alt: "Digital signage content playing on a display at office premises which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-13.7EnBBIkEm_Ho.webp`,
    alt: "Digital signage content playing on a standee display at an event premises which is powered by Pickcel",
  },
  {
    src: `${cdnBaseUrl}/images/gallery/slider/slide-14.SkoOPsmxtPsc.webp`,
    alt: "Digital signage content playing on a standee display at a cinema premises which is powered by Pickcel",
  },
];

interface DigitalSignageGalleryCarouselProps {
  className?: string;
}

export default function DigitalSignageGalleryCarousel({
  className = "",
}: DigitalSignageGalleryCarouselProps) {
  return (
    <section className={`py-20 overflow-hidden ${className}`}>
      <Swiper
        modules={[Autoplay]}
        slidesPerView={10}
        spaceBetween={15}
        loop={true}
        speed={5000}
        autoplay={{
          delay: 0.1,
          disableOnInteraction: true,
        }}
        breakpoints={{
          0: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 7,
            spaceBetween: 15,
          },
        }}
        className="gallery-list-swiper"
      >
        {galleryImages.map((image, index) => (
          <SwiperSlide key={index}>
            <div className="w-full">
              <Image
                src={image.src}
                alt={image.alt}
                title={image.alt}
                width={204}
                height={226}
                loading={index < 7 ? "eager" : "lazy"}
                priority={index < 7}
                className="w-full h-auto"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

